import {
  NgSignaturePadOptions,
  SignaturePadComponent,
} from "@almothafar/angular-signature-pad";
import { HttpEventType } from "@angular/common/http";
import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as dayjs from "dayjs";
import { NgxImageCompressService } from "ngx-image-compress";
import { ComboDisplay } from "src/app/models/dto/combo-display.dto";
import { AlertasSwalService } from "src/app/services/alerts.service";
import dataURItoBlob from "src/app/utils/dataURItoBlob";
import { FuncionamientoService } from "src/app/views/catalogs/funcionamiento/funcionamiento.service";
import { UnidadesService } from "src/app/views/recepcion/unidades/unidades.service";
import { OperadoresService } from "src/app/views/workers/operadores/operadores.service";
import { ProgramarService } from "../../programar/programar.service";
import { MantenimientoService } from "../mantenimiento.service";

@Component({
  selector: "app-form-mantenimiento",
  templateUrl: "./form.component.html",
})
export class MantenimientoForm implements OnInit {
  @ViewChild("signatureChofer")
  public signatureChoferPad: SignaturePadComponent;
  @ViewChild("signatureSupervisor")
  public signatureSupervisorPad: SignaturePadComponent;

  public signaturePadOptions: NgSignaturePadOptions = {
    // passed through to szimek/signature_pad constructor
    minWidth: 5,
    canvasWidth: 400,
    canvasHeight: 300,
    backgroundColor: "rgb(255,255,255)",
  };

  @ViewChild("imageInput", { static: false }) public imageInput: ElementRef;
  @ViewChild("licenciaInput", { static: false })
  public licenciaInput: ElementRef;
  public fileList: File[] = [];
  public imagesList: any[] = [];

  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  public unidades: any[] = [];
  public supervisores: ComboDisplay[] = [];
  public operadores: ComboDisplay[] = [];
  public funcionamientos: any[] = [];
  public observaciones: any[] = [];

  public currentUnidad: any = undefined;
  public currentIdUnidad: any = undefined;
  public currentOperador: any = undefined;
  public currentIdOperador: any = undefined;
  public currentSupervisor: any = undefined;
  public currentIdSupervisor: any = undefined;
  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();
  @Output() reload = new EventEmitter();

  public gasValue = 0;

  markerConfig = {
    "30": {
      color: "#555",
      size: 8,
      label: "30",
      type: "line",
    },
    "70": {
      color: "#555",
      size: 8,
      label: "60",
      type: "line",
    },
    "100": {
      color: "#555",
      size: 8,
      label: "100",
      type: "line",
    },
  };

  thresholdConfig = {
    "60": {
      color: "green",
      bgOpacity: 0.2,
    },
    "25": {
      color: "orange",
      bgOpacity: 0.2,
    },
    "0": {
      color: "red",
      bgOpacity: 0.2,
    },
  };

  public tarjetaCirculacionBool = false;
  public tarjetaCirculacionDate = dayjs().toDate();

  public polizaBool = false;
  public polizaDate = dayjs().toDate();

  public kms = 0;
  public llantas = 100;

  public golpesBool = false;
  public choferImg = "";
  public supImg = "";
  public licenciaImg = "";
  constructor(
    private fb: FormBuilder,
    private uniServ: UnidadesService,
    private opeServ: OperadoresService,
    private funcServ: FuncionamientoService,
    private serv: MantenimientoService,
    private servPro: ProgramarService,
    private imageCompress: NgxImageCompressService,
    private alerts: AlertasSwalService
  ) {}

  public ngOnInit() {
    this.buildForm();
    this.uniServ.get().subscribe((s) => {
      this.unidades = s;
    });
    this.opeServ.getListas().subscribe((s) => {
      this.operadores = s.Choferes;
      this.supervisores = s.Supervisores;
    });
    this.funcServ.get().subscribe((s) => {
      this.funcionamientos = s.map((m) => {
        return { Id: m.IdFuncionamiento, Desc: m.Descripcion, Value: false };
      });
    });
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate(row: any) {
    this.mode = "create";
    this.defaults = row;
    this.form.reset();
    this.currentIdUnidad = row.IdUnidad;
    this.currentUnidad = this.unidades.find(
      (f) => f.IdUnidad == this.currentIdUnidad
    );
  }

  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;
    this.servPro.getByIdRecepcion(row.IdMantenimiento).subscribe((next) => {
      this.currentSupervisor = this.supervisores.find(
        (f) => f.Id == next.IdSupervisor
      );

      this.currentUnidad = this.unidades.find(
        (f) => f.IdUnidad == next.IdUnidad
      );

      this.currentOperador = this.operadores.find((f) => f.Id == next.IdChofer);

      this.kms = next.Kilometraje;
      this.gasValue = next.TanqueGas;
      this.polizaBool = next.Poliza;
      this.polizaDate = dayjs(next.PolizaVigencia).toDate();
      this.tarjetaCirculacionBool = next.TarjetaCirculacion;
      this.tarjetaCirculacionDate = dayjs(
        next.TarjetaCirculacionVigencia
      ).toDate();

      this.choferImg = next.firmachofer;
      this.supImg = next.firmaSupervisor;
      this.licenciaImg = next.licencia;
      this.funcionamientos = next.Funcionamientos;
      this.observaciones = next.Observaciones;
      this.imagesList = next.images;
    });
  }

  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public async create() {
    const firmaChoferData = this.signatureChoferPad.toDataURL("image/jpeg");
    const fileChofer = await this.fileFromDataUrl(firmaChoferData);

    const firmaSupervisorData =
      this.signatureSupervisorPad.toDataURL("image/jpeg");
    const fileSupervisor = await this.fileFromDataUrl(firmaSupervisorData);

    const context = {
      IdMantenimiento: this.defaults.IdMantenimiento,
      IdChofer: this.currentIdOperador,
      IdSupervisor: this.currentIdSupervisor,
      IdUnidad: this.currentIdUnidad,
      Kilometraje: this.kms,
      PolizaBool: this.polizaBool,
      PolizaVigencia: dayjs(this.polizaDate).toISOString(),
      TanqueGas: this.gasValue,
      TarjetaCirculacionBool: this.tarjetaCirculacionBool,
      TarjetaCirculacionVigencia: dayjs(
        this.tarjetaCirculacionDate
      ).toISOString(),
      Funcionamientos: this.funcionamientos,
      Observaciones: this.observaciones,
      Llantas: this.llantas,
      Golpes: this.golpesBool,
    };
    this.servPro
      .addRecepcion(
        context,
        this.fileList,
        fileChofer,
        fileSupervisor,
        this.licenciaFile
      )
      .subscribe(
        (event) => {
          if (event.type === HttpEventType.Response) {
            if (event.ok) {
              this.alerts.correcta("Correcto", "Recepcion guardada");

              this.observaciones = [];

              this.currentUnidad = undefined;
              this.currentIdUnidad = undefined;
              this.currentOperador = undefined;
              this.currentIdOperador = undefined;
              this.currentSupervisor = undefined;
              this.currentIdSupervisor = undefined;

              this.gasValue = 0;

              this.tarjetaCirculacionBool = false;
              this.tarjetaCirculacionDate = dayjs().toDate();

              this.polizaBool = false;
              this.polizaDate = dayjs().toDate();

              this.kms = 0;

              this.choferImg = "";
              this.supImg = "";
              this.licenciaImg = "";
              this.imagesList = [];
              this.fileList = [];
              this.mode = "stanby";

              this.reload.emit();
              this.funcServ.get().subscribe((s) => {
                this.funcionamientos = s.map((m) => {
                  return {
                    Id: m.IdFuncionamiento,
                    Desc: m.Descripcion,
                    Value: false,
                  };
                });
              });
            } else {
              this.alerts.error("Error", "Ocurrio un error");
            }
          }
        },
        (err) => {
          this.alerts.error("Error", "Ocurrio un error");
        }
      );
    // this.onsave.emit({ mode: this.mode, value: this.form.value });
  }

  public update() {
    this.onsave.emit({ mode: this.mode, value: this.form.value });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      // IdUnidad: [""],
      // IdEmpresa: [""],
      // IdTipoUnidad: [""],
      // NoControl: [""],
      // Serie: [""],
      // Placas: [""],
      // Modelo: [""],
      // Estado: [""],
      // FechaIngreso: [""],
    });
  }
  selectSupervisor(e) {
    this.currentSupervisor = this.supervisores.find((f) => f.Id == e);
  }
  selectOperador(e) {
    this.currentOperador = this.operadores.find((f) => f.Id == e);
  }

  addObservacion(e) {
    const val = { Id: new Date().getTime().toString(36), Desc: e };

    this.observaciones.push(val);
  }

  removeObservacion(e) {
    this.observaciones = [...this.observaciones.filter((f) => f.id !== e)];
  }

  public getFile() {
    this.imageCompress.uploadFile().then(({ image, orientation }) => {
      this.imageCompress
        .compressFile(image, orientation, 50, 50) // 50% ratio, 50% quality
        .then((compressedImage) => {
          const blob = dataURItoBlob(compressedImage);
          this.imagesList.push(compressedImage);
          this.fileList.push(
            new File([blob], "Imagen" + new Date().getTime().toString(16))
          );
        });
    });
  }

  public removeImage(src) {
    const inx = this.imagesList.findIndex((f) => f == src);
    this.imagesList.splice(inx, 1);
    this.fileList.splice(inx, 1);
  }

  licenciaFile: File = undefined;
  OpenLicenseSelect() {
    this.licenciaInput.nativeElement.click();
  }

  public getLicense(licenciaInput: any) {
    if (licenciaInput.files.length > 0) {
      Array.from(licenciaInput.files).forEach(async (file) => {
        await this.processLicense(file);
      });
    }
  }

  processLicense(file: any) {
    const reader: FileReader = new FileReader();

    const promise: Promise<void> = new Promise((resolve) => {
      reader.onload = () => {
        this.licenciaImg = reader.result as string;
        this.licenciaFile = file;
        resolve();
      };
      reader.readAsDataURL(file);
    });
    return promise;
  }

  async fileFromDataUrl(dataURL) {
    const blob = await (await fetch(dataURL)).blob();
    const file = new File([blob], "fileName.jpg", {
      type: "image/jpeg",
      lastModified: new Date().getTime(),
    });
    return file;
  }

  cleanSupervisor() {
    this.signatureSupervisorPad.clear();
  }
  cleanChofer() {
    this.signatureChoferPad.clear();
  }
  public imgDef =
    "https://tanzolymp.com/images/default-non-user-no-photo-1.jpg";
  public valueImgChofer = "";
  public loadImageChofer() {
    this.opeServ.image(this.currentIdOperador).subscribe(
      (str) => (this.valueImgChofer = str),
      (err) => (this.valueImgChofer = this.imgDef)
    );
  }
  errorHandlerChofer(event) {
    event.target.src = this.imgDef;
  }
  public valueImgSupervisor = "";
  public loadImageSupervisor() {
    // this.supServ.image(this.currentIdSupervisor).subscribe( TODO
    //   (str) => (this.valueImgSupervisor = str),
    //   (err) => (this.valueImgSupervisor = this.imgDef)
    // );
  }
  errorHandlerSupervisor(event) {
    event.target.src = this.imgDef;
  }
  removeLicencia() {
    this.licenciaImg = "";
    this.licenciaFile = undefined;
  }
}
